<mat-sidenav-container class="app-main-container">
  <mat-sidenav-content>
    <igo-backdrop [shown]="backdropShown" (click)="onBackdropClick()" />

    <div
      class="navbar-container"
      [class.--empty-spacer]="sidenavOpened"
      [style.width.px]="sidenavOpened && sidenavWidth ? sidenavWidth : '400'"
    >
      @if (showMenuButton) {
        <igo-menu-button
          [class.mat-elevation-z2]="!sidenavOpened"
          [sidenavOpened]="sidenavOpened"
          (openSidenav)="onToggleSidenavClick()"
        />
      }

      @if (showSearchBar) {
        <igo-search-bar
          #searchBar
          [class.mat-elevation-z2]="!sidenavOpened"
          [term]="searchBarTerm"
          [termSplitter]="termSplitter"
          [minLength]="minSearchTermLength"
          [searchSettings]="true"
          [forceNA]="appConfig.app?.forceCoordsNA"
          [store]="searchStore"
          (searchTermChange)="onSearchTermChange($event)"
          [pointerSummaryEnabled]="igoSearchPointerSummaryEnabled"
          [allowResetSearchSourcesOptions]="
            appConfig.allowResetSearchSourcesOptions
          "
          (pointerSummaryStatus)="onPointerSummaryStatusChange($event)"
          [searchResultsGeometryEnabled]="searchResultsGeometryEnabled"
          (searchResultsGeometryStatus)="
            onSearchResultsGeometryStatusChange($event)
          "
          [reverseSearchCoordsFormatEnabled]="
            igoReverseSearchCoordsFormatEnabled
          "
          (reverseSearchCoordsFormatStatus)="
            onReverseCoordsFormatStatusChange($event)
          "
          (search)="onSearch($event)"
          (clearFeature)="onClearSearch()"
          (searchSettingsChange)="onSearchSettingsChange()"
        />
      }
    </div>

    <app-sidenav
      [map]="map"
      [(opened)]="sidenavOpened"
      (toolChange)="toolChanged($event)"
      (widthChange)="handleWidth($event)"
    />
    <igo-map-browser
      igoMapOffline
      igoWorkspaceUpdator
      [workspaceStore]="workspaceStore"
      igoLongPress
      igoSearchPointerSummary
      [igoSearchPointerSummaryDelay]="500"
      [igoSearchPointerSummaryEnabled]="igoSearchPointerSummaryEnabled"
      igoHoverFeature
      [igoHoverFeatureDelay]="250"
      [igoHoverFeatureEnabled]="true"
      #mapBrowser
      igoQuery
      [waitForAllQueries]="true"
      [queryFeatures]="true"
      [queryFeaturesHitTolerance]="15"
      igoMapContext
      igoLayerContext
      (contextLayersLoaded)="contextLayersLoaded$.next($event)"
      igoDropGeoFile
      [contextUri]="contextUri"
      (query)="onMapQuery($event)"
      [map]="map"
      [igoContextMenu]="contextMenu"
      (menuPosition)="onContextMenuOpen($event)"
      [ngClass]="{
        'igo-attribution-offset': map.layerController.baseLayers.length > 1
      }"
      [@mapStateX]="sidenavOpened ? 'right' : 'left'"
      (@mapStateX.start)="updateMapBrowserClass()"
      [@mapStateY]="getControlsOffsetY()"
      (@mapStateY.start)="updateMapBrowserClass()"
    >
      <div class="map-actions --vertical --top --right">
        <div class="spinner-spacer"></div>
        <igo-rotation-button
          class="mat-elevation-z2"
          [showIfNoRotation]="appConfig.showRotationButtonIfNoRotation"
          [map]="map"
          color="primary"
        />
      </div>
      <div
        class="map-actions --vertical --bottom --right"
        [@controlsOffsetY]="getControlsOffsetY()"
        [@mobileOffsetY]="getToastPanelStatus()"
      >
        @if (appConfig.offlineButton) {
          <igo-offline-button
            [map]="map"
            color="primary"
            class="mat-elevation-z2"
            [@controlsOffsetY]="getControlsOffsetY()"
            [@mobileOffsetY]="getToastPanelStatus()"
          />
        }
        @if (appConfig.homeExtentButton) {
          <igo-home-extent-button
            class="mat-elevation-z2"
            [map]="map"
            [extentOverride]="homeExtent"
            [centerOverride]="homeCenter"
            [zoomOverride]="homeZoom"
            color="primary"
          />
        }
        @if (appConfig.wakeLockApiButton) {
          <igo-wake-lock-button class="mat-elevation-z2" />
        }
        @if (hasGeolocateButton) {
          <igo-geolocate-button
            class="mat-elevation-z2"
            [map]="map"
            color="primary"
            [@controlsOffsetY]="getControlsOffsetY()"
            [@mobileOffsetY]="getToastPanelStatus()"
          />
        }
        @if (!isTouchScreen) {
          <igo-zoom-button
            [map]="map"
            color="primary"
            [@controlsOffsetY]="getControlsOffsetY()"
          />
        }
      </div>
      <div
        class="map-actions --horizontal --bottom --right"
        [@controlsOffsetY]="getControlsOffsetY()"
        [@mobileOffsetY]="getToastPanelStatus()"
      >
        @if (authService.hasAuthService) {
          <igo-user-button
            class="mat-elevation-z2"
            [map]="map"
            color="primary"
            [@controlsOffsetY]="getControlsOffsetY()"
            [@mobileOffsetY]="getToastPanelStatus()"
          />
        }
      </div>
      <div
        class="map-actions --vertical --bottom --left"
        [@controlsOffsetY]="getControlsOffsetY()"
        [@mobileOffsetY]="getToastPanelStatus()"
        [style.left.px]="sidenavOpened && sidenavWidth ? sidenavWidth + 4 : ''"
      >
        <igo-baselayers-switcher
          class="mat-elevation-z2"
          [map]="map"
          [@controlsOffsetY]="getBaselayersSwitcherStatus()"
          [useStaticIcon]="true"
        />
        @if (
          appConfig.hasExpansionPanel &&
          (workspaceState.workspaceEnabled$ | async) &&
          !workspaceState.expanded()
        ) {
          <app-expansion-panel-button [(expanded)]="workspaceState.expanded" />
        }
      </div>
      <igo-swipe-control class="mat-elevation-z2" [map]="map" />
      <igo-map-center class="mat-elevation-z2" [map]="map" />
    </igo-map-browser>

    <app-map-overlay
      [@controlStateY]="getControlsOffsetY()"
      [@controlStateX]="
        (mediaService.media$ | async) !== 'mobile' && sidenavOpened
          ? 'right'
          : 'left'
      "
    />
  </mat-sidenav-content>
</mat-sidenav-container>

@if (workspaceState.expanded()) {
  <app-expansion-panel
    [backdropShown]="expansionPanelBackdropShown"
    [(expanded)]="workspaceState.expanded"
    [maximized]="workspaceState.workspaceMaximize$ | async"
    [@expansionPanelSize]="getExpansionPanelStatus()"
    [@toastOffsetY]="
      isMobile() &&
      !toastPanelOpened &&
      queryState.store.entities$.value.length > 0 &&
      !workspaceState.expanded()
        ? 'true'
        : 'false'
    "
  >
    <ng-container expansionPanelHeader>
      <igo-workspace-selector
        igoWorkspaceSelector
        (changeWorkspace)="workspaceState.setActiveWorkspaceByTitle($event)"
        (disableSwitch)="workspaceSwitchDisabled = $event"
        (relationLayers)="refreshRelationsWorkspace($event)"
        (rowsInMapExtentCheckCondition)="
          workspaceState.rowsInMapExtentCheckCondition$.next($event)
        "
        [store]="workspaceStore"
        [disabled]="workspaceSwitchDisabled"
        [map]="map"
      />
      @if (selectedWorkspace$ | async; as workspace) {
        <div class="workspace-container">
          <div class="workspace-actions">
            <button
              class="eye-workspace"
              mat-icon-button
              [color]="workspace.layer.visible ? 'primary' : 'default'"
              collapsibleButton
              tooltip-position="below"
              matTooltipShowDelay="500"
              [matTooltip]="
                workspace.layer.visible
                  ? ('igo.geo.layer.hideLayer' | translate)
                  : ('igo.geo.layer.showLayer' | translate)
              "
              (click)="onWorkspaceLayerToggle(workspace.layer.id)"
            >
              <mat-icon
                [ngClass]="{
                  disabled: (workspace.inResolutionRange$ | async) !== true
                }"
              >
                {{ workspace.layer.visible ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
            @if (isEditionWorkspace(workspace)) {
              <button
                class="add-feature"
                mat-icon-button
                color="primary"
                collapsibleButton
                tooltip-position="below"
                matTooltipShowDelay="500"
                [disabled]="
                  workspace.layer.options.sourceOptions.edition.addButton ===
                  false
                    ? true
                    : false
                "
                [matTooltip]="'workspace.addFeature' | translate"
                (click)="addFeature(workspace)"
              >
                <mat-icon>add</mat-icon>
              </button>
            }
            @if (workspace.actionStore) {
              <igo-actionbar
                class="actionbar-workspace"
                [store]="workspace.actionStore"
                [withIcon]="true"
                [withTitle]="actionbarWithTitle"
                [horizontal]="true"
                [withToggleButton]="actionbarMode === 'overlay'"
                [iconColor]="'primary'"
                [color]="'primary'"
                [mode]="actionbarMode"
                [overlayClass]="workspaceMenuClass"
              />
            }
            @if (workspaceVisibility()) {
              <button
                class="zoom-workspace"
                [disabled]="
                  (workspaceState.workspaceSelection$ | async).length === 0
                    ? true
                    : false
                "
                mat-icon-button
                color="primary"
                collapsibleButton
                tooltip-position="below"
                matTooltipShowDelay="500"
                [matTooltip]="'toastPanel.zoomOnFeaturesTooltip' | translate"
                (click)="zoomToSelectedFeatureWks()"
              >
                @if ((workspaceState.workspaceSelection$ | async).length > 1) {
                  <mat-icon>frame_inspect</mat-icon>
                } @else {
                  <mat-icon>zoom_in </mat-icon>
                }
              </button>
            }
          </div>
          @if (workspaceVisibility()) {
            <igo-entity-table-paginator
              [store]="workspace.entityStore"
              [entitySortChange$]="workspaceEntitySortChange$"
              [paginatorOptions]="paginatorOptions"
              (paginatorChange)="paginatorChange($event)"
            />
          }
        </div>
      }
    </ng-container>
    @if (selectedWorkspace$ | async; as workspace) {
      @if (
        workspace.entityStore &&
        workspace.meta &&
        workspace.meta.tableTemplate &&
        workspaceVisibility()
      ) {
        <igo-entity-table
          [class]="isEditionWorkspace(workspace) ? 'edition-table' : ''"
          [paginator]="workspacePaginator"
          [store]="workspace.entityStore"
          (entitySortChange)="entitySortChange()"
          (entitySelectChange)="entitySelectChange($event)"
          [template]="workspace.meta.tableTemplate"
        />
      }
      <span>{{ workspaceNotAvailableMessage | translate }}</span>
    }
  </app-expansion-panel>
}

<app-toast-panel-for-expansion
  [withHeader]="false"
  [(opened)]="toastPanelForExpansionOpened"
  [@toastPanelOffsetX]="toastPanelOffsetX$ | async"
>
  <div class="toast-panel-for-expansion-close-button-container">
    <button mat-icon-button color="warn" (click)="closeWidget()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (selectedWorkspace$ | async; as workspace) {
    <igo-workspace-widget-outlet
      [workspace]="workspace"
      (deactivateWidget)="onDeactivateWorkspaceWidget()"
    />
  }
</app-toast-panel-for-expansion>

@if ((queryStore.empty$ | async) !== true) {
  <app-toast-panel
    [map]="map"
    [store]="queryStore"
    [hasFeatureEmphasisOnSelection]="appConfig.hasFeatureEmphasisOnSelection"
    [@toastPanelOffsetX]="toastPanelOffsetX$ | async"
    [@toastPanelOffsetY]="getToastPanelOffsetY()"
    [@toastPanelMobileSidenav]="
      (isMobile() && sidenavOpened) ||
      (isTablet() && isPortrait() && sidenavOpened)
    "
    [opened]="toastPanelOpened"
    (openedChange)="toastOpenedChange($event)"
    (fullExtentEvent)="fullExtent = $event"
    (windowHtmlDisplayEvent)="setToastPanelHtmlDisplay($event)"
  />
}

<ng-template #contextMenu>
  <igo-actionbar
    [store]="contextMenuStore"
    [withIcon]="false"
    [horizontal]="true"
    mode="context"
  />
</ng-template>
